import React from 'react'

import { makeStyles } from '@material-ui/core/styles'

import { greyMultibrandPalette } from '@masfront/common-b2c/src/modules/ui/theme/colors'
import { CustomTheme } from '@masfront/common-b2c/src/modules/ui/theme/utils'

import { subscriptionStatusGroupText } from '~/customer/helpers'
import { SubscriptionStatusGroup } from '~/customer/model/customer.model'
import B2CAlert from '~/ui/components/B2CAlert/B2CAlert'

type AlertVariant = 'big' | 'small' | 'chip' | 'rounded'

interface LineStatusGroupProps {
  status: SubscriptionStatusGroup
  variant?: AlertVariant
}

const useStyles = makeStyles((theme: CustomTheme) => {
  return {
    root: {
      backgroundColor: (props: LineStatusGroupProps) => {
        switch (props.status) {
          case SubscriptionStatusGroup.ACTIVE:
            return theme.palette.success.light
          case SubscriptionStatusGroup.ON_FLY:
            return theme.palette.warning.main
          case SubscriptionStatusGroup.LOCKED:
          case SubscriptionStatusGroup.TERMINATED:
            return theme.palette.error.main
          case SubscriptionStatusGroup.PENDING:
          case SubscriptionStatusGroup.NO_GROUP:
          default:
            return greyMultibrandPalette[300]
        }
      },
      '& .MuiAlert-message': {
        color: (props: LineStatusGroupProps) => {
          switch (props.status) {
            case SubscriptionStatusGroup.ACTIVE:
            case SubscriptionStatusGroup.ON_FLY:
            case SubscriptionStatusGroup.PENDING:
            case SubscriptionStatusGroup.NO_GROUP:
              return greyMultibrandPalette[900]
            default:
              return theme.palette.common.white
          }
        },
      },
    },
  }
})

const LineStatusGroup: React.FC<LineStatusGroupProps> = ({ status, variant = 'big' }) => {
  const classes = useStyles({ status, variant })
  const lineStatusText =
    variant === 'chip'
      ? subscriptionStatusGroupText[status].letter
      : subscriptionStatusGroupText[status].text

  return <B2CAlert className={classes.root} variant={variant} alertText={lineStatusText} />
}

export default LineStatusGroup
